const PLATFORM_LOANS_HOME_BASE_PATH = 'platform/loans';
const PLATFORM_LOAN_BASE_PATH = ':loanNumber';
const PLATFORM_DRAW_BASE_PATH = ':drawId';
const PLATFORM_EXTENSION_BASE_PATH = ':extensionId';

export const getPlatformLoanRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return {
    loans: (loanNumber?: string) => ({
      path: `${basePath}/${PLATFORM_LOANS_HOME_BASE_PATH}/${PLATFORM_LOAN_BASE_PATH}`,
      url: `${baseUrl}/${PLATFORM_LOANS_HOME_BASE_PATH}/${loanNumber}`,
      children: {
        dashboard: {
          path: `${basePath}/${PLATFORM_LOANS_HOME_BASE_PATH}/${PLATFORM_LOAN_BASE_PATH}/dashboard`,
          url: `${baseUrl}/${PLATFORM_LOANS_HOME_BASE_PATH}/${loanNumber}/dashboard`,
          documentTitle: `${loanNumber} - Loan Dashboard`,
        },
        tasks: {
          path: `${basePath}/${PLATFORM_LOANS_HOME_BASE_PATH}/${PLATFORM_LOAN_BASE_PATH}/tasks`,
          url: `${baseUrl}/${PLATFORM_LOANS_HOME_BASE_PATH}/${loanNumber}/tasks`,
          documentTitle: `Tasks - ${loanNumber}`,
        },
        draws: {
          path: `${basePath}/${PLATFORM_LOANS_HOME_BASE_PATH}/${PLATFORM_LOAN_BASE_PATH}/draws`,
          url: `${baseUrl}/${PLATFORM_LOANS_HOME_BASE_PATH}/${loanNumber}/draws`,
          documentTitle: `Loan Draws - ${loanNumber}`,
        },
        drawDetails: (drawId?: string) => ({
          path: `${basePath}/${PLATFORM_LOANS_HOME_BASE_PATH}/${PLATFORM_LOAN_BASE_PATH}/draws/${PLATFORM_DRAW_BASE_PATH}`,
          url: `${baseUrl}/${PLATFORM_LOANS_HOME_BASE_PATH}/${loanNumber}/draws/${drawId}`,
          documentTitle: `Draw Details - ${drawId}`,
        }),
        extensions: {
          path: `${basePath}/${PLATFORM_LOANS_HOME_BASE_PATH}/${PLATFORM_LOAN_BASE_PATH}/extension`,
          url: `${baseUrl}/${PLATFORM_LOANS_HOME_BASE_PATH}/${loanNumber}/extension`,
          documentTitle: `Loan Extension Request - ${loanNumber}`,
        },
        extensionDetails: (extensionId?: string) => ({
          path: `${basePath}/${PLATFORM_LOANS_HOME_BASE_PATH}/${PLATFORM_LOAN_BASE_PATH}/extension/${PLATFORM_EXTENSION_BASE_PATH}`,
          url: `${baseUrl}/${PLATFORM_LOANS_HOME_BASE_PATH}/${loanNumber}/extension/${extensionId}`,
          documentTitle: `Extension Details - ${extensionId}`,
        }),
        payoffRequest: {
          path: `${basePath}/${PLATFORM_LOANS_HOME_BASE_PATH}/${PLATFORM_LOAN_BASE_PATH}/payoff`,
          url: `${baseUrl}/${PLATFORM_LOANS_HOME_BASE_PATH}/${loanNumber}/payoff`,
          documentTitle: `Loan Payoff Request - ${loanNumber}`,
        },
      },
    }),
  };
};
